const productsMonthly = [
  {
    name: "Lite",
    price: "3.50",
    description: "Limited features compared to core plans",
    subscriptionDetails: [
      "No Free Trial",
      "No Personalization",
      "15 Decisions / mo",
    ],
    apiId: "price_1M32GqDa6qlpCRXeVriKuKgK",
    productId: "prod_MmbTm21doXReuB",
    directLink: "https://buy.stripe.com/28o4h853zffx0PS9AE",
  },
  {
    name: "Single",
    price: "9.90",
    description: "Comes with a 9-day free trial and more",
    subscriptionDetails: [
      "9-day Free Trial",
      "Money-back Guarantee",
      "Unlimited Decisons",
    ],
    apiId: "price_1MntK8Da6qlpCRXeX7vwIVMG",
    productId: "prod_MmbUvWdQc3zXIM",
    directLink: "https://buy.stripe.com/5kA7tk53z2sLbuwbIJ",
  },
  {
    name: "Family",
    price: "21.80",
    description: "Perfect for families to share. Unlimited Decisions",
    subscriptionDetails: [
      "Multiple Profiles",
      "Money-back Guarantee",
      "Unlimited Decisons",
    ],
    apiId: "price_1M32GeDa6qlpCRXevQDXWM8c",
    productId: "prod_MmbTleo4UbvjLX",
    directLink: "https://buy.stripe.com/dR63d4cw13wP1TW7su",
  },
];

export default productsMonthly;
